let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6v9IN")).then(() => parcelRequire('gNFjT'));